const fr = {
    RoleManagement: "Gestion des rôles",
    SuperAdminSubtitle:
      "En tant que Super Admin, vous pouvez modifier le rôle de chaque utilisateur",
    TotalRecord: "Enregistrements total",
    NoSuperAdminAccess:
      "Vous n’avez pas les droits Super Admin pour accéder à cette page",
    GoogleEmail: "Email Google",
    UserName: "Nom d’utilisateur",
    UserRole: "Rôle utilisateur",
    PhoneNumber: "Numéro de téléphone",
    Actions: "Actions",
    AskMeExample: "Demandez-moi par exemple",
    GiveMeInhouseClientsList: "Donne-moi la liste des clients Inhouse",
    WhatIsNextBirthday: "Quel est le prochain anniversaire",
    SummarizeLatestNotes: "Fais-moi un résumé des dernières notes",
    WhereCanISeeInhouseClientsList:
      "Où puis-je voir la liste des clients Inhouse",
    WelcomeToRehappApp: "Bienvenue sur Rehapp",
    LatestSupportTickets: "Derniers tickets de support",
    NoTicketsFound: "Aucun ticket trouvé",
    Reset: "Réinitialiser",
    PleaseSendTicket:
      "Veuillez nous envoyer un ticket pour tout problème que vous avez",
    SupportTickets: "Tickets de support",
    DashboardHelp:
      "Accédez au tableau de bord pour une vue d'ensemble des activités et des statistiques clés.",
    ClientsHelp:
      "Gérez tous les clients par type (En interne, Après-soins, À venir, etc.).",
    NotesHelp:
      "Permet de voir les notes et de les filtrer par type de notes pour suivre les interactions avec les clients.",
    RoomAvailabilityHelp:
      "Permet de voir le nombre de chambres disponibles par jour.",
    RoomBookingHelp:
      "Montre le détail très précis par jour des réservations effectuées, avec les noms des clients et des détails spécifiques.",
    CRMHelp:
      "Présente un kanban avec les cartes clients par statut, permettant de gérer l'état d'avancement de qualification des leads.",
    MetricsHelp: "Affiche diverses métriques et statistiques.",
    ExportDataHelp:
      "Exporte les données clients au cas où le client souhaite récupérer ses données.",
    DocumentsHelp:
      "Permet de stocker des documents accessibles à tous les autres utilisateurs.",
    SupportHelp:
      "Permet d'envoyer des tickets au support pour obtenir de l'aide.",
    InHouseClientsInfo:
      "Ici, vous pouvez voir le nombre total de clients qui sont actuellement en cours d'admission. Cliquez sur ce widget pour plus de détails sur ces clients.",
    NextClientDepartureInfo:
      "Ce widget affiche le prochain client prévu pour le départ, y compris son nom et la date de sortie prévue. Cliquez pour voir plus d'informations sur ce client.",
    NextIncomingClientInfo:
      "Ce widget montre le prochain client entrant, avec sa date d'arrivée prévue. Cliquez pour en savoir plus sur ce client entrant.",
    UpcomingClientsInfo:
      "Ce widget présente le nombre total de clients qui sont prévus d'arriver bientôt. Cliquez pour plus de détails sur ces clients à venir.",

    MandatoryFormsSection:
      "Ceci est la section 'Formulaires obligatoires' où vous pouvez ajouter, visualiser et gérer tous les formulaires essentiels requis pour l'admission et le processus de traitement du client. Assurez-vous que tous les documents nécessaires sont complétés et à jour pour respecter les réglementations et fournir des soins complets.",
    AuthorizationSection:
      "Ceci est la section 'Autorisation de divulgation d'informations confidentielles'. Ici, vous avez la possibilité de gérer et d'ajouter de nouveaux formulaires d'autorisation qui permettent la divulgation des informations confidentielles d'un client à des parties autorisées. Il est important de traiter ces documents avec soin pour maintenir la confidentialité et respecter les exigences légales.",
    SearchBar:
      "Ceci est la barre de recherche où vous pouvez rechercher des clients en entrant leur nom ou d'autres informations pertinentes. Cela vous aide à localiser rapidement et à accéder aux détails d'un client, rendant votre flux de travail plus efficace.",
    AIServicePrompt:
      "Essayez notre service IA ici ! Cette fonctionnalité utilise une intelligence artificielle avancée pour vous aider dans diverses tâches, rendant votre expérience plus fluide et intuitive. Cliquez ici pour explorer comment l'IA peut améliorer votre productivité et offrir des solutions intelligentes.",
    ProfileWidget:
      "Ceci est votre widget de profil où vous pouvez gérer les paramètres de votre compte, visualiser vos informations de profil et accéder à vos préférences personnelles. Il fournit un moyen rapide de personnaliser votre expérience et de rester à jour avec les détails de votre compte.",

    PreviousWeek: "Semaine précédente",
    NextWeek: "Semaine suivante",
    AgeNonEditable: "Âge (non modifiable)",
    PageConcerned: "Page concernée",
    AddNewTicket: "Ajouter un nouveau ticket",
    WriteDescription: "Écrivez une description de votre problème ci-dessous",
    UploadScreenshots:
      "Téléchargez des captures d'écran du problème ci-dessous si vous en avez",
    TicketName: "Nom du ticket",
    Priority: "Priorité",
    TicketType: "Type de ticket",
    Medium: "Moyenne",
    Low: "Faible",
    High: "Élevée",
    DateOfBirth: "Date de naissance",
    DateOfBirthRequired: "La date de naissance est requise",
    Create: "Créer",
    AddNewLead: "Ajouter un nouveau lead",
    UpdateLead: "Mettre à jour le lead",
    PhoneNumberRequired: "Le numéro de téléphone est requis",
    FailedToCreateOrUpdateLead:
      "Échec de la création/mise à jour du lead. Veuillez réessayer.",
    LeadUpdatedSuccessfully: "Lead mis à jour avec succès!",
    LeadCreatedSuccessfully: "Lead créé avec succès!",
    ClientProfile: "Profil du client",
    YearsOld: "ans",
    NoPrimaryAddictionRecorded: "Aucune addiction principale enregistrée",
    Dashboard: "Accueil",
    Clients: "Clients",
    ClientsC: "CLIENTS",
    Client: "Client",
    ClientC: "CLIENT",
    Notes: "Notes",
    MyProfile: "Mon Profil",
    RoomAvailability: "Disponibilité des chambres",
    RoomBooking: "Réservation de chambre",
    Metrics: "Métriques",
    ExportData: "Exporter les données",
    Documents: "Documents",
    SearchClient: "Rechercher un client...",
    Settings: "Paramètres",
    SignOut: "Déconnexion",
    NextDeparture: "PROCHAIN DEPART",
    NextIncoming: "PROCHAINE ARRIVEE",
    Incoming: "# ARRIVEES",
    Incoming2: "Incoming",
    NoDischarges: "Aucun départ",
    NoUpcomingClient: "Aucun client à venir",
    LastClientNotes: "Notes récentes",
    Date: "Date",
    DateC: "DATE",
    Content: "Contenu",
    ContentC: "CONTENU",
    Type: "TYPE",
    Edit: "Modifier",
    Delete: "Supprimer",
    ShowMoreNotes: "Voir plus de notes",
    ShowLessNotes: "Voir moins de notes",
    ClickHereForHelp: "Cliquez ici pour obtenir de l'aide à l'écran",
    AddClient: "Ajouter un client",
    AddTheClient: "Ajouter le client",
    AddNewClient: "Ajouter un nouveau client",
    FirstName: "Prénom",
    LastName: "Nom de famille",
    LastName2: "Nom",
    Nickname: "Surnom",
    Gender: "Genre",
    Email: "E-mail",
    PhoneNumber: "Numéro de téléphone",
    Country: "Pays",
    PrimaryAddiction: "Addiction principale",
    PrimaryAddictionT: "1ere Addiction",
    DurationOfStay: "Durée du séjour",
    ETA: "Heure d'arrivée",
    ClientSource: "Source du client",
    ProjectedResidentialDischargeDate: "Date de sortie résidentielle prévue",
    ProjectedProgramCompletionDate: "Date prévue de fin de programme",
    ProjectedResidentialDischargeDateRequired:
      "La date de sortie résidentielle prévue est requise",
    ProjectedProgramCompletionDateRequired:
      "La date prévue de fin de programme est requise",
    PersonalInfos: "Infos personnelles",
    AddictionInfos: "Infos sur l'addiction",
    DischargeInfos: "Infos sur la sortie",
    FirstNameRequired: "Le prénom est requis",
    LastNameRequired: "Le nom de famille est requis",
    NicknameRequired: "Le surnom est requis",
    EmailRequired: "L'email est requis",
    ETARequired: "La date d'arrivée est requise",
    Back: "Retour",
    Next: "Suivant",
    Finish: "Terminer",
    DemoTestNoClient: "Version de démonstration : Aucun client ajouté :)",
    ClientName: "Nom du client",
    TypeQuickSessionNote: "Tapez une note de session rapide ici",
    NoteContent: "Contenu de la note",
    EffectiveDateTime: "Date et heure effectives de la note",
    EffectiveDate: "Date et heure effectives",
    NoteContent: "Contenu de la note",
    TypeNoteHere: "Tapez votre note ici",
    StartShift: "Début du quart de travail",
    TypeNoteHere: "Tapez votre note ici",
    EndShift: "Fin du quart de travail",
    SelectStaff: "Sélectionnez le personnel",
    EffectiveDateOnly: "Date effective",
    FamilyNoteRelationship: "Relation de la note de famille",
    GroupTopic: "Sujet du groupe",
    GroupDateStartTime: "Date et heure de début du groupe",
    TypeOfGroup: "Type de groupe",
    GroupNote: "Note de groupe",
    TypeGroupNoteHere: "Tapez la note de groupe ici",
    ClientsNotInAttendance: "Clients NON présents",
    TypeNamesHere:
      "Tapez les noms ici (prénom / ou prénom préféré et initiale du nom de famille) et la raison pour laquelle le client n'est pas en groupe, si connue...",
    ImmigrationAppointment: "Rendez-vous d'immigration / visa",
    DischargesFlights: "Arrangements de sorties / vols",
    NewClients: "Nouveaux clients",
    PsychiatristAppointments: "Rendez-vous avec le psychiatre",
    HospitalAppointments: "Rendez-vous à l'hôpital",
    Outings: "Sorties",
    ZoomSessionAssistance: "Assistance de session Zoom",
    StaffToday: "Personnel aujourd'hui",
    Overnight: "De nuit",
    NumberOfClients: "Nombre de clients",
    Swot: "Swot",
    GeneralAnnouncement: "Annonce générale / Discussion",
    EditFamilyNote: "Modifier la note de famille",
    EditQuickNote: "Modifier la note rapide",
    EditAftercareNote: "Modifier la note de suivi",
    EditGroupNote: "Modifier la note de groupe",
    EditMedicalNote: "Modifier la note médicale",
    EditSupportStaffNote: "Modifier la note du personnel de soutien",
    EditTherapyNote: "Modifier la note de thérapie",
    EditHandoverNote: "Modifier la note de passation",
    Cancel: "Annuler",
    Save: "Sauvegarder",
    TypeGroupNoteHere: "Tapez votre note de groupe ici",
    TypeMedicalNoteHere: "Tapez votre note médicale ici",
    ImportFile: "Importer un fichier",
    MaximumFileSize: "Taille maximale du fichier : 50 Mo",
    SelectedFile: "Fichier sélectionné",
    FileAlreadyUploaded: "Fichier déjà téléchargé",
    AreYouSureToDeleteFile: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
    Confirm: "Confirmer",
    ConfirmDeletion: "Confirmer la suppression",
    TotalRecord: "enregistrement",
    Filters: "Filtres",
    SelectClientType: "Sélectionner le type de client",
    SelectTherapist: "Sélectionner le thérapeute",
    SelectAddiction: "Sélectionner l'addiction",
    SelectILS: "Sélectionner l'ILS",
    ResetFilters: "Réinitialiser les filtres",
    ADDICTION: "ADDICTION",
    AKA: "SURNOM",
    AGE: "ÂGE",
    ADMISSION: "ADMISSION",
    THERAPIST: "THÉRAPEUTE",
    ROOM: "CHAMBRE #",
    SUPPORT_STAFF: "SUPPORT",
    PleaseSelectBothDates:
      "Veuillez sélectionner les dates de début et de fin.",
    SelectRangeDate: "Sélectionner une plage de dates :",
    SeeMore: "Voir plus",
    TO: "À",
    RoomsAvailablePerDay: "Chambres disponibles / jour",
    DistributionPerDay: "Répartition / jour",
    RoomAvailability: "Disponibilité des chambres",
    RoomBooking: "Réservation de chambres",
    FullscreenMode: "Mode plein écran",
    NoCredentials:
      "--Vous n'avez pas les identifiants Super-admin ou Admin pour accéder à cette page--",
    ExitFullscreen: "Quitter le plein écran",
    TodaysDate: "Date d'aujourd'hui",
    IncomingDischarges: "Départs à venir",
    NightsMo: "Nuits sur le mois",
    LOSToDate: "Durée de résidence à ce jour",
    LOSIntended: "Durée de résidence (Prévu)",
    TotalNightsBooked: "Total des nuits réservées",
    TotalIncomingNights: "Total des nuits à venir",
    TotalPotentialNights: "Total des nuits potentielles",
    TotalProjectedNights: "Total des nuits projetées",
    January: "Janvier",
    February: "Février",
    March: "Mars",
    April: "Avril",
    May: "Mai",
    June: "Juin",
    July: "Juillet",
    August: "Août",
    September: "Septembre",
    October: "Octobre",
    November: "Novembre",
    December: "Décembre",
    InHouseClients: "# Clients Inhouse",
    BedOccRate: "Taux d'occ. des lits",
    AvTreatmentDur: "Durée moy. de trait.",
    ClientsByAddictionTypeInhouse: "Clients par type de dépendance (Internes)",
    ClientsByAddictionTypeAllClients:
      "Clients par type de dépendance (Tous les clients)",
    ClientsByTherapistInhouse: "Clients par thérapeute (Internes)",
    Day: "Jours",
    Status: "Statut",
    Nationality: "Nationalité",
    SecondaryAddiction: "Seconde Addiction",
    LengthOfStay: "Durée du séjour",
    InActiveRecovery: "En récupération active?",
    GoogleReviewDone: "Revue Google faite?",
    ExportData: "Export des données",
    ExportData2: "Exporter les données",
    Documents: "Documents",
    UPLOADING: "TÉLÉCHARGEMENT...",
    UPLOAD: "TÉLÉCHARGER",
    NoFileSelected:
      "Aucun fichier sélectionné, veuillez en sélectionner un et mettre un nom de fichier",
    ChooseFile: "Choisir le fichier",
    FileRequirements:
      "(un à la fois, seulement PDF, JPG ou PNG avec une taille maximale de 5MB)",
    UploadDocument: "Télécharger un fichier de document",
    NoFilesFound: "Aucun fichier trouvé",
    NoDeletePermissions:
      "Vous n'avez pas la permission de supprimer ce fichier",
    OneFileLimit: "Vous ne pouvez télécharger qu'un seul fichier",
    FileDeleted: "Fichier supprimé avec succès !",
    ErrorDeletingFile: "Erreur lors de la suppression du fichier",
    FileSizeExceedsLimit: "La taille du fichier dépasse la limite :",
    FilesUploaded: "Fichiers téléchargés avec succès !",
    ErrorUpdatingClient: "Erreur lors de la mise à jour du client :",
    NoFilesSelected: "Aucun fichier sélectionné pour le téléchargement.",
    FileName: "Nom du fichier",
    AreYouSureYouWantToDeleteTheFile:
      "Êtes-vous sûr de vouloir supprimer le fichier",
    permanently: "définitivement ?",
    TryOurAI: "Essayez notre I.A.",
    ArtificialIntelligence: "I.A.",
    Photo: "Photo",
    Email: "Email",
    PhoneNumber: "Numéro de téléphone",
    Role: "Rôle",
    Edit: "Modifier",
    ChooseFile: "Choisir un fichier",
    Profile: "Profil",
    ProfileUpdatedSuccessfully: "Profil mis à jour avec succès",
    ErrorUpdatingProfile: "Erreur lors de la mise à jour du profil :",
    User: "Utilisateur",
    SuccessfullyLoggedOut: "déconnecté avec succès",
    LogOut: "Se déconnecter",
    Name: "Nom",
    AskMeAnything: "Demandez-moi n'importe quoi",
    PromptInstruction:
      "Dans le champ ci-dessous, posez-moi toutes vos questions sur cet EHR et sur les clients. Vous pouvez poser des questions dans n'importe quelle langue.",
    AnonymizedRequests:
      "Toutes les demandes sont anonymisées (les vrais noms des clients ne sont pas soumis au modèle d'IA).",
    AskAbout: "Demandez sur :",
    HowToAddClient: "Comment ajouter un client ?",
    GenerateReport: "Puis-je générer un rapport sur les progrès des clients ?",
    JanesProgress: "Comment se passe le progrès de Jane ?",
    JohnsRecentNotes: "Quelles sont les dernières notes de John ?",
    SummaryOfNotes: "Donnez-moi un résumé des notes de la semaine dernière.",
    NoteAddedSuccess: "Note ajoutée avec succès",
    SelectedClient: "Client sélectionné",
    NoClientSelected: "--Aucun client sélectionné--",
    SelectAClient: "Sélectionnez un client",
    TypeNamesAndReason:
      "Tapez les noms ici (prénom / ou nom préféré et initiale du nom de famille) et la raison pour laquelle le client n'est pas dans le groupe, si connu...",
    IfOtherDescribe: "Si autre, décrivez",
    StartOfShift: "Début de service",
    EndOfShift: "Fin de service",
    SelectStaff: "Sélectionner le personnel",
    Add: "Ajouter",
    EditEndOfShiftNote: "Modifier la note de fin de quart",
    WelcomeToRehabAppDemo: "Bienvenue sur Rehab-App (Démo)",
    ContinueWithGoogle: "Continuer avec Google",
    LogInWithGoogle: "Se connecter avec Google",
    InternetConnectionWorking: "Votre connexion Internet fonctionne",
    InternetConnectionNotWorking:
      "Votre connexion Internet ne fonctionne pas. Veuillez vérifier votre connexion Internet.",
    SuccessfullyLoggedInWithGoogle:
      "Connecté avec succès en utilisant votre compte Google",
    MustLogInWithMiraclesAsiaEmail:
      "Vous devez vous connecter avec une adresse e-mail se terminant par @miraclesasia.com pour accéder à cette application.",
    FailedToLogInWithGoogle: "Échec de la connexion avec votre compte Google",
    NoRoleFoundForUser: "Aucun rôle trouvé pour cet utilisateur dans Firestore",
    MustLogInWithGmailOrGsuite:
      "Vous devez vous connecter avec une adresse Gmail ou G Suite pour accéder à cette application.",
    ClientNameRequired: "Le nom du client est requis",
    ContentRequired: "Le contenu est requis",
    EffectiveDateRequired: "La date effective est requise",
    ImmigrationAppointmentRequired: "Le rendez-vous d'immigration est requis",
    DischargesFlightsRequired: "Les départs / vols sont requis",
    NewClientsRequired: "Les nouveaux clients sont requis",
    PsychiatristAppointmentsRequired:
      "Les rendez-vous psychiatriques sont requis",
    HospitalAppointmentsRequired: "Les rendez-vous à l'hôpital sont requis",
    OutingsRequired: "Les sorties sont requises",
    ZoomSessionAssistanceRequired: "L'assistance aux sessions Zoom est requise",
    StaffTodayRequired: "Le personnel d'aujourd'hui est requis",
    OvernightRequired: "La nuit est requise",
    NumberOfClientsRequired: "Le nombre de clients est requis",
    SwotRequired: "SWOT est requis",
    GeneralAnnouncementRequired: "L'annonce générale est requise",
    GroupTopicRequired: "Le sujet du groupe est requis",
    StartTimeRequired: "L'heure de début est requise",
    GroupTypeRequired: "Le type de groupe est requis",
    NotInAttendanceRequired: "Non présents sont requis",
    StartOfShiftRequired: "Le début du quart est requis",
    EndOfShiftRequired: "La fin du quart est requise",
    StaffRequired: "Le personnel est requis",
    PleaseFillAllRequiredFields: "Veuillez remplir tous les champs requis",
    PersonalInformation: "Informations personnelles",
    FirstName: "Prénom",
    LastName: "Nom de famille",
    Nickname: "Surnom",
    Email: "Email",
    PhoneNumber: "Numéro de téléphone",
    Birthday: "Anniversaire",
    AgeNotEditable: "Âge (non modifiable)",
    MaritalStatus: "État civil",
    LivingWith: "Vit avec",
    IfOtherDescribe: "Si autre, décrire",
    Gender: "Genre",
    IfOtherGenderDescribe: "Si autre genre, décrire",
    SexualOrientation: "Orientation sexuelle",
    PhysicalAddressOfResidence: "Adresse physique de résidence",
    City: "Ville",
    ProvinceState: "Province / État",
    Country: "Pays",
    Nationality: "Nationalité",
    ClientSource: "Source du client",
    PassportNumber: "Numéro de passeport",
    VisaExpirationDate: "Date d'expiration du visa",
    TreatmentInformation: "Informations sur le traitement",
    ClientStatus: "Statut du client",
    RoomNumber: "Numéro de chambre",
    AssignedTherapist: "Thérapeute assigné",
    AssignedSupportStaff: "Personnel de soutien assigné",
    AdmissionAndDischarge: "Admission & Décharge",
    ActualAdmissionDate: "Date d'admission réelle",
    ActualDischargeDate: "Date de sortie réelle",
    ProjectedDischargeDate: "Date de sortie prévue",
    ProjAftercareCompletionDate: "Date d'achèvement des soins prévus",
    PassportPictures: "Photos de passeport",
    ImportFile: "Importer un fichier",
    MaximumFileSize: "Taille maximale du fichier : 100 Mo",
    UploadingFile: "Téléchargement du fichier...",
    UploadedFiles: "Fichier(s) téléchargé(s)",
    EmergencyContact: "Contact d'urgence",
    EmergencyContactFirstName: "Prénom du contact d'urgence",
    EmergencyContactLastName: "Nom de famille du contact d'urgence",
    Relationship: "Relation",
    IfOtherDescribe: "Si autre, décrire",
    ContactPhoneNumber: "Numéro de téléphone du contact",
    ContactEmail: "Email du contact",
    PhysicalAddressOfResidence: "Adresse physique de résidence",
    City: "Ville",
    Nationality: "Nationalité",
    StateProvince: "État / Province",
    Country: "Pays",
    PersonPayingForTreatment: "Personne payant pour le traitement",
    PhoneNumberOfPersonPaying: "Numéro de téléphone de la personne payante",
    SavingModifications: "ENREGISTREMENT DES MODIFICATIONS...",
    ClickToSave: "CLIQUEZ POUR ENREGISTRER",
    SaveModifications: "ENREGISTRER LES MODIFICATIONS",
    UploadLimitExceeded:
      "Vous pouvez uniquement télécharger jusqu'à 3 fichiers.",
    FileSizeExceedsLimit: "La taille du fichier dépasse la limite :",
    FilesSuccessfullyUploaded: "Fichier(s) téléchargé(s) avec succès !",
    FileSuccessfullyDeleted: "Fichier supprimé avec succès !",
    ErrorDeletingFile: "Erreur lors de la suppression du fichier",
    GeneralInformation: "Informations Générales",
    ActivityLogs: "Journaux d'Activité",
    Help: "Aide",
    Close: "Fermer",
    NoRecentActivity: "Aucune activité récente",
    Language: "Langue",
    Admin: "ADMIN",
    NoClientIdentifier: "Aucun identifiant client",
    NoTherapistAssignedYet: "Aucun thérapeute assigné pour le moment",
    AssignedTherapist: "Thérapeute assigné :",
    IntendedDurationOfStay: "Durée prévue du séjour",
    AdmissionDate: "Date d'admission",
    MandatoryForms: "Formulaires obligatoires",
    AreYouSureToDeleteNote: "Êtes-vous sûr de vouloir supprimer cette note ?",
    AreYouSureToDeleteFile: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
    FileSuccessfullyDeleted: "Fichier supprimé avec succès !",
    ErrorDeletingFile: "Erreur lors de la suppression du fichier",
    NoteSuccessfullyDeleted: "Note supprimée avec succès !",
    ErrorDeletingNote: "Erreur lors de la suppression de la note :",
    Deleting: "Suppression...",
    Updating: "Mise à jour...",
    NoRecentActivity: "Aucune activité récente",
    LastModification: "Dernière modification",
    ClientAddedBy: "Client ajouté par",
    EstimateDateOfArrival: "Date d'arrivée estimée",
    IntendedDurationOfStay: "Durée de séjour prévue",
    PassportStatus: "Statut du passeport",
    PassportCopy: "Copie du passeport",
    PrevClientIdentifier: "Identifiant client précédent",
    FlightDetails: "Détails du vol",
    Itinerary: "Itinéraire",
    VIPTransfer: "Transfert VIP",
    PaymentDetails: "Détails de paiement",
    MaritalStatus: "Statut marital",
    CurrentPartnerIfNotMarried: "Partenaire actuel si non marié?",
    ChildrensOrDependents: "Enfants ou personnes à charge",
    CurrentLivingArrangements: "Arrangements de vie actuels",
    DietaryRequirements: "Exigences alimentaires",
    FundingSource: "Source de financement",
    PrimAddSubstOrProcAbove: "Add. principale (soit subst. ou proc. ci-dessus)",
    IfOtherSelectedDescribe: "Si autre sélectionné, décrire",
    SecondaryAddiction: "Addiction secondaire",
    IfOtherSelectedDescribeSecondary: "Si autre sélectionné, décrire",
    SubstanceAddictions: "Addiction(s) aux substances",
    DoCCurrentUsageLevels:
      "Niveaux d'utilisation actuels (fréquence, quantité) et méthode (fumage, injection, reniflement, oralement)",
    AnyCurrentWithdrawalSymptoms: "Symptômes de sevrage actuels",
    ProcessAddictions: "Addiction(s) aux processus",
    TypeProcessAddiction:
      "type, par ex. jeu, sexe, pornographie, nourriture, jeux vidéo ; et fréquence des comportements d'addiction aux processus",
    AddictionTreatmentHistory: "Historique du traitement de l'addiction",
    MainUnwantedConsequences:
      "Principales conséquences indésirables de l'addiction",
    HowLongHasAddictionBeenAProblem:
      "Depuis combien de temps votre addiction (usage/alcool/processus) est-elle un problème?",
    WhatLedYouToSeekTreatmentNow:
      "Qu'est-ce qui vous a poussé à rechercher un traitement maintenant?",
    TreatmentGoals: "Objectifs de traitement",
    BarriersForRehab: "Barrières pour la réadaptation",
    MotivationForTreatment: "Motivation pour le traitement",
    SavingModifications: "SAUVEGARDE DES MODIFICATIONS...",
    ClickToSave: "CLIQUEZ POUR ENREGISTRER",
    SaveModifications: "ENREGISTRER LES MODIFICATIONS",
    Addictions: "addictions",
    PreAdmissionAssessment: "Évaluation pré-admission",
    AdmissionForms: "Formulaires d'admission",
    AuthorizationReleaseConfidentialInfo:
      "Autorisation de divulgation d'informations confidentielles",
    AddRCIForm: "Ajouter un formulaire R.C.I.",
    UnableToAddMandatoryForms:
      "Impossible d'ajouter des formulaires obligatoires si le client n'est pas admis.",
    UnableToAddROIForm:
      "Impossible d'ajouter un formulaire de R.O.I. si le client n'est pas admis.",
    CompanyIndividualName: "Nom de l'entreprise / Individu",
    Filled: "Rempli",
    Revoked: "Révoqué",
    Actions: "Actions",
    Relationship: "Relation",
    SelectedClient: "Client sélectionné :",
    ConfidentialityPolicyForm: "Formulaire de politique de confidentialité",
    PleaseSignBelow:
      "Veuillez signer ci-dessous et cliquer sur Valider une fois terminé",
    SignatureNotValidated: "Signature non validée",
    SignatureValidated: "Signature validée!",
    Clear: "Effacer",
    Validate: "Valider",
    Saving: "Enregistrement...",
    GeneralLiabilityReleaseForm: "Décharge de responsabilité générale",
    GeneralLiabilityFormSubmitted:
      "Formulaire de décharge de responsabilité générale soumis avec succès !",
    ErrorAddingDocument: "Erreur lors de l'ajout du document",
    InformedConsentForm: "Consentement éclairé",
    InformedConsentFormSubmitted:
      "Formulaire de consentement éclairé soumis avec succès !",
    ConfidentialityPolicyFormSubmitted:
      "Politique de confidentialité soumis avec succès !",
    PleaseAgreeToTerms: "Veuillez accepter tous les termes avant de soumettre.",
    Print: "Imprimer",
    Intervention: "Intervention",
    AddTreatment: "Ajouter un traitement",
    Adding: "Ajout en cours...",
    Objective: "Objectif",
    AddObjective: "Ajouter un objectif",
    ObjectivesAssociatedInterventions:
      "Objectifs et interventions associées pendant le traitement au centre de réhabilitation :",
    PresentingIssues: "Problème(s) présenté(s) :",
    LongTermGoals: "Objectifs à long terme (au-delà du traitement au centre) :",
    FailedToSaveTreatmentPlan:
      "Échec de l'enregistrement du plan de traitement. Veuillez réessayer.",
    TreatmentPlanSuccessfullyAdded: "Plan de traitement ajouté avec succès !",
    PleaseFillRequiredFields: "Veuillez remplir tous les champs obligatoires.",
    ObjectiveIntervention: "Objectif / Intervention",
    TreatmentPlan: "Plan de traitement",
    DischargeSummary: "Résumé de la sortie",
    DischargeDate: "Date de sortie",
    DischargeType: "Type de sortie",
    DischargeTo: "Sortie vers",
    DateOfAdmission: "Date d'admission",
    TotalLengthOfStay: "Durée totale du séjour",
    MedicationPrescribedUponDischarge: "Médicaments prescrits à la sortie",
    IdentifiedIssuesUponAdmission: "Problèmes identifiés à l'admission",
    EmergingIssuesDuringTreatment:
      "Problèmes émergents identifiés pendant le traitement",
    OverallLevelOfEngagement: "Niveau général d'engagement dans le programme",
    Resistance: "Résistance",
    HighlyEngaged: "Très engagé",
    Progress: "Progrès",
    FamilyInvolvement: "Implication de la famille / du partenaire significatif",
    RoadblocksConcerns: "Obstacles/Préoccupations",
    ClientPrognosis: "Pronostic du client",
    RecommendedDischargePlan: "Plan de sortie recommandé",
    StaffMemberName: "Nom du membre du personnel",
    Submit: "Soumettre",
    LeaveAgainstClinicalAdvice: "Départ Contre Avis Médical (ACA)",
    EmergencyDischarge: "Sortie d'urgence",
    TreatmentPlanFor: "Plan de traitement pour:",
    EditTreatmentPlan: "Modifier le plan de traitement",
    Review: "Revue",
    TypeReviewHere: "Tapez la revue ici",
    AddReviews: "Ajouter des revues",
    UpdateReviews: "METTRE À JOUR LES REVUES",
    Updating: "MISE À JOUR EN COURS...",
    ObjectiveReviewsUpdated:
      "Les revues des objectifs ont été mises à jour avec succès !",
    FailedToUpdateObjectiveReviews:
      "Échec de la mise à jour des revues des objectifs. Veuillez réessayer.",
    TreatmentPlanUpdated:
      "Le plan de traitement a été mis à jour avec succès !",
    FailedToSaveTreatmentPlan:
      "Échec de l'enregistrement du plan de traitement. Veuillez réessayer.",

    SelectNoteType: "Sélectionner le type de note",
    StartDate: "Date de début",
    EndDate: "Date de fin",
    AddNote: "Ajouter une note",
    TotalNote: "Note totale",
    GeneralDocuments: "Documents généraux",
    TherapistsDocuments: "Documents des thérapeutes",
    CRM: "CRM",
    Medication: "Médication",
    Invoicing: "Facturation",
    Support: "Support",
    AddAlert: "Ajouter une alerte",
    EditAlert: "Modifier l'alerte",
    PleaseSelectTypeAndContent:
      "Veuillez sélectionner un type et entrer le contenu pour l'alerte",
    ConfirmDeleteAlert: "Êtes-vous sûr de vouloir supprimer l'alerte ?",
    ShowMore: "Voir plus",
    ShowLess: "Voir moins",
    Alerts: "ALERTES",
    ClinicalInformations: "Informations Cliniques",
    AddTreatmentPlan: "Ajouter un Plan de Traitement",
    NoTreatmentPlanAdded:
      "AUCUN PLAN DE TRAITEMENT AJOUTÉ. VEUILLEZ AJOUTER UN PLAN DE TRAITEMENT",
    Added: "Ajouté",
    Reviewed: "Revu",
    DischargeForms: "Formulaires de sortie",
    PrimaryAddictionColon: "Addiction Principale :",
    NoAdmissionDateYet: "Aucune date d'admission pour le moment",
    NoDurationOfStayYet: "Aucune durée de séjour pour le moment",
  };

export default fr;
